module.exports = __webpack_public_path__ + "img/icon_presentation.1611c194.png";